export default __webpack_public_path__ + "static/media/coeur.324b2f8f.svg";